module.exports = __webpack_public_path__ + "static/img/designGuide3.56a8ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide3.png
// module id = yxP/
// module chunks = 2